import React, { useState } from 'react';
import { Box } from '@mui/material';
import { GMIcon } from '../assets/icons/icons';
import { useTheme } from '@mui/material';
import { useIntl } from 'react-intl';
import Dialog from '../dialogs/dialog/Dialog';

export default function Footer() {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const [openDisclaimer, setOpenDisclaimer] = useState(false);

  return (
    <Box
      role="contentinfo"
      container
      zIndex={2}
      backgroundColor={theme.palette.grey[900]}
      width="100%"
      pl={3}
      pt={2}
      position="fixed"
      bottom="0"
      sx={{
        [theme.breakpoints.up('sm')]: {
          position: 'relative',
          px: '50px',
          pt: '25px',
          pb: '25px',
        },
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        sx={(theme) => ({
          alignItems: 'start',
          flexDirection: 'column',
          rowGap: '16px',
          [theme.breakpoints.up('md')]: {
            alignItems: 'center',
            flexDirection: 'row',
          },
        })}
      >
        <GMIcon />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'start',
            flexDirection: 'column',
            rowGap: '8px',
            flexBasis: '50%',
            [theme.breakpoints.up('sm')]: {
              alignItems: 'center',
              flexDirection: 'row',
            },
          }}
        >
          <Box
            className="footer-disclaimer"
            pl={{ xs: '0', sm: '24px' }}
            mb={{ xs: '0', sm: '-5px' }}
          >
            <p>EV solutions provided by ZappyRide®, a J.D. Power business.</p>
            <p>
              Figures shown on this page are estimates based on data provided by third-parties. This
              material is provided for informational purposes only and should not be relied on for
              tax, legal, or financial advice. Neither J.D. Power® nor GM provides tax, legal or
              financial advice. You should independently verify the estimates provided here before
              engaging in any transaction.
            </p>
          </Box>
        </Box>
      </Box>
      <Dialog
        isOpen={openDisclaimer}
        title={formatMessage({ id: 'incentive.dialogTitle' })}
        onClose={() => setOpenDisclaimer(false)}
      >
        {formatMessage({ id: 'incentive.disclaimer' })}
      </Dialog>
    </Box>
  );
}
